import './RetailTracSnapshot.scss';
import React from 'react';

import AccountLayoutHeader from 'components/layouts/AccountLayoutHeader/AccountLayoutHeader';
import ProductSnapshotCard from 'components/layouts/Snapshot/ProductSnapshotCard';
import { getIntradayPricing } from "services/Rest";
import { getRetailTracAccounts } from 'state/account/AccountSelectors';
import { connect } from 'react-redux';
import { retailTracEnabled } from 'services/FeatureFlags';
import { externalAuthorizationTracPath } from 'services/ExternalAuthorizationURLBuilder';
import { AAMBeaconButton } from 'components/shared/Beacon';
import { getCustomerWebView } from 'state/customer/CustomerSelectors';

const RetailTracSnapshot = ({accounts, isCustomerWebView}) => {

    if(!retailTracEnabled()) {
        return false;
    }

    const data = {
        accounts: accounts
    };

    const footer = (
        <AAMBeaconButton
            id={'link-button-small-business-retirement'}
            linkHref={externalAuthorizationTracPath}
            linkTarget="_blank"
            variant={'secondary'}
            scale={'normal'}
            disabled={isCustomerWebView}
        >
            Manage Small Business Accounts
        </AAMBeaconButton>
    );

    return (
        <div className="retail-trac-snapshot">
            <AccountLayoutHeader
                text="Small Business Retirement Plan Accounts"
                link="/accounts"
                detailText="View Small Business Retirement Details"
                isSubheader={false}
                hideDetailLink={true}
            />
            <ProductSnapshotCard
                hideTitleBar={true}
                footer={footer}
                data={data}
                onRefresh={getIntradayPricing}
                accounts={accounts}
            />
        </div>
    );
};

const mapStateToProps = (state) => ({
    accounts: getRetailTracAccounts(state),
    isCustomerWebView: getCustomerWebView(state)
});

export default connect(mapStateToProps)(RetailTracSnapshot)
